
function salesCount(count: number) {
  if (isNaN(count)) return '0'
  if (count > 10000) {
    const f = parseInt(`${count / 10000}`)
    const l = parseInt(`${(count % 10000 / 1000).toFixed(1)}`)
    return `${f}.${l}w`
  }
  return count || '0'
}

export {
  salesCount,
}